import HttpService from './baseHttp'

// 库存异动单查询
export const HttpGetInventoryAdjustmentList = (data = {}) => HttpService.post("/api/v2/inventory/adjustment/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 库存异动单重新审核
export const HttpConfirmInventoryAdjustment = (data = {}) => HttpService.post("/api/v2/inventory/adjustment/confirm", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 库存异动单添加备注
export const HttpAdjustmentAddRemark = (data = {}) => HttpService.post("/api/v2/inventory/adjustment/addRemark", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 库存异动单忽略差异
export const HttpAdjustmentIgnoreComplete = (data = {}) => HttpService.post("/api/v2/inventory/adjustment/ignoreComplete", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询明细
export const HttpAdjustmentDetail = (data = {}) => HttpService.post("/api/v2/inventory/adjustment/detail", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询调整明细
export const HttpAdjustmentItemDetail = (data = {}) => HttpService.post("/api/v2/inventory/adjustment/itemDetail", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查看操作历史
export const HttpGetAdjustmentLog = (data = {}, config) => HttpService.get('/api/v2/OrderLog/query', { params: data })